<template>
  <div class="seal_form">
    <van-nav-bar
      title="印章外借列表"
      left-text="返回"
      left-arrow
      @click-left="goto('mobile')"
    >
      <template #right>
        <van-icon
          name="search"
          size="18"
          @click="searchInfo = true"
          style="margin-right: 10px"
        />
        <van-icon name="down" @click="downData" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        @load="onLoad"
        finished-text="没有更多了"
      >
        <van-cell
          title="申请人"
          v-for="item in sealData"
          :value="item.name"
          @click="onclick(item)"
        />
      </van-list>
    </van-cell-group>
    <van-popup class="formInfoPop" title="印章外借详情" v-model="showformInfo">
      <van-form ref="vForm2" v-model="sealDataItem">
        <van-field v-model="sealDataItem.name" readonly label="申请人" />
        <van-field v-model="sealDataItem.applyDate" readonly label="申请日期" />
        <van-field
          v-model="sealDataItem.companyName"
          readonly
          label="公司名称"
        />
        <van-field v-model="sealDataItem.sealType" readonly label="印章类型" />
        <van-field
          v-model="sealDataItem.planBorrowDate"
          readonly
          label="预计外借时间"
        />
        <van-field
          v-model="sealDataItem.planBackDate"
          readonly
          label="预计归还时间"
        />
        <van-field
          v-model="sealDataItem.realBorrowDate"
          readonly
          label="实际借出时间"
        />
        <van-field
          v-model="sealDataItem.realBackDate"
          readonly
          label="实际归还时间"
        />
        <van-field
          v-model="sealDataItem.returnerName"
          readonly
          label="归还人"
        />
        <div class="flex-row flex-center mt20 mb20">
          <van-button type="primary" size="small" style="margin-right: 20px"
            >外 借</van-button
          >
          <van-button type="info" size="small">归 还</van-button>
        </div>
      </van-form>
    </van-popup>

    <van-popup class="formInfoPop" title="查询信息" v-model="searchInfo">
      <van-form ref="vForm">
        <van-field
          label="申请人"
          v-model="queryParams.params.name"
          clearable
          placeholder="请输入申请人"
        />
        <van-field
          label="公司名称"
          v-model="queryParams.params.companyName"
          clearable
          placeholder="请输入公司名称"
        />
        <van-field
          label="印章类型"
          v-model="queryParams.params.sealType"
          clearable
          placeholder="请输入印章类型"
        />
        <div class="flex-row flex-center mt20 mb20">
          <van-button class="width80" plain type="danger" @click="onSearch"
            >查询</van-button
          >
        </div>
      </van-form>
    </van-popup>
  </div>
</template>
<script>
import {
  Empty,
  List,
  NavBar,
  Button,
  Cell,
  CellGroup,
  Form,
  Field,
  Popup,
  Calendar,
  Icon,
  Toast,
} from "vant";
import * as Api from "@/api/sealBorrowApi";
import { formatDate } from "../../util/formatUtil";
import axiosl from "axios";
export default {
  data() {
    return {
      sealData: [], //印章数据
      queryParams: {
        page: 1,
        size: 10,
        params: {
          name: "", //申请人
          applyDate: "", //申请时间
          companyName: "", //公司名称
          sealType: "", //印章类型
        },
      },
      totalCount: 0, //总条数
      finished: false,
      showformInfo: false,
      sealDataItem: [], //每一项申请信息
      searchInfo: false,
      applyDate: false,
      loading:false,
    };
  },
  components: {
    [Empty.name]: Empty,
    [List.name]: List,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Form.name]: Form,
    [Popup.name]: Popup,
    [Calendar.name]: Calendar,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
  },
  mounted() {
    this.getSealData();
  },
  methods: {
    getSealData() {
      let params = JSON.parse(JSON.stringify(this.queryParams));
      Api.getListPage(params).then((res) => {
        if (res.code != "0000") {
           Toast.fail({
            message: res.msg,
          });
        }
        this.totalCount = res.data.totalElements;
        this.sealData = res.data.content;
      });
    },
    onclick(item) {
      this.showformInfo = true;
      this.sealDataItem = item;
    },
    onSearch() {
      this.getSealData();
      this.searchInfo = false;
    },
    onConfirm(date) {
      this.applyDate = false;
      let da = formatDate(date, "yyyy-MM-dd");
      this.queryParams.params.applyDate = da;
    },
     onLoad() {
      //触底查询
      this.queryParams.page += 1;
      let _this = this;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      Api.getListPage(params).then((res) => {
        if (res.success) {
          _this.sealData = _this.sealData.concat(res.data.content);
          if (_this.sealData.length >= res.data.totalElements) {
            _this.finished = true;
          } else {
            _this.finished = false;
          }
          _this.loading = false;
        }
      });
    },
    downData() {
      //导出数据
      if (this.totalCount === 0) {
        Toast.error("没有可以导出的数据");
        return;
      }
      let _this = this;
      const size = this.queryParams.size;
      this.queryParams.size = this.totalCount > 10000 ? 10000 : this.totalCount;
      let token = document.cookie.match(
        new RegExp("(^| )tenant_user_token=([^;]*)(;|$)")
      )[2];
      axiosl
        .post("/eip-mapp-oa-server/oa_seal_form/export", this.queryParams, {
          headers: { keyId: token },
          responseType: "blob",
        })
        .then((res) => {
          this.queryParams.size = size;
          _this.convertRes2Blob(res);
        });
    },
    convertRes2Blob(response) {
      let filename = "印章外借数据查询导出结果.xls";
      // 将二进制流转为blob
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
        window.navigator.msSaveBlob(blob, decodeURI(filename));
      } else {
        // 创建新的URL并指向File对象或者Blob对象的地址
        const blobURL = window.URL.createObjectURL(blob);
        // 创建a标签，用于跳转至下载链接
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", decodeURI(filename));
        // 兼容：某些浏览器不支持HTML5的download属性
        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }
        // 挂载a标签
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        // 释放blob URL地址
        window.URL.revokeObjectURL(blobURL);
      }
    },
  },
};
</script>
<style scoped>
.bottom {
  display: flex;
  border-bottom: 1px solid #ebedf0;
  width: 100%;
}
.formInfoPop {
  width: 90vw;
}
</style>
